import React from "react";
import './AddonButton.css'

const AddonButton = ({ visible, onClick }) => {
  if (!visible) return null;

  return (
    <button className="addon-button-wrap" onClick={onClick}>
      Highlight New Boxes
    </button>
  );
};

export default AddonButton;
